<template>
    <div class="file clearfix" :class="[fileSize]">
        <i class="file__icon">
            <GifIcon v-if="getIcon(file.fileName) == 'gif'" />
            <JpgIcon v-if="getIcon(file.fileName) == 'jpg'" />
            <PdfIcon v-if="getIcon(file.fileName) == 'pdf'" />
            <SvgIcon v-if="getIcon(file.fileName) == 'svg'" />
            <BinIcon v-if="getIcon(file.fileName) == 'bin'" />
            <PngIcon v-if="getIcon(file.fileName) == 'png'" />
        </i>
        <div class="file__progress">
            <div class="file__progress-name">{{ file.fileName }}</div>
            <ProgressLoader :progress="file.progress" :total="file.total" />
        </div>

        <button
            v-if="cancelable"
            class="file__delete icon-cancel button"
            @click="cancelLoading(file)"
        >
            <CloseIcon />
        </button>
    </div>
</template>

<script>
import ProgressLoader from '@/components/common/ProgressBar.vue';

//SVG
import CloseIcon from 'Svgs/close.svg?inline?inline';
import BinIcon from 'Svgs/fileicons-bin.svg?inline';
import GifIcon from 'Svgs/fileicons-gif.svg?inline';
import JpgIcon from 'Svgs/fileicons-jpg.svg?inline';
import PdfIcon from 'Svgs/fileicons-pdf.svg?inline';
import SvgIcon from 'Svgs/fileicons-svg.svg?inline';
import PngIcon from 'Svgs/fileicons-png.svg?inline';

export default {
    components: {
        ProgressLoader,
        CloseIcon,
        BinIcon,
        GifIcon,
        JpgIcon,
        PdfIcon,
        SvgIcon,
        PngIcon,
    },
    props: {
        file: {
            type: Object,
            required: true,
        },
        size: {
            type: String,
            default: '',
        },
        cancelable: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        fileSize() {
            return this.size ? `file--${this.size}` : '';
        },
    },
    methods: {
        getIcon(name, fileType) {
            if (fileType && fileType === 'video') {
                return 'ytb';
            }
            const types = 'png, jpg, svg, pdf, gif, ycp';
            let type = name.split('.')[1].toLowerCase();
            return types.indexOf(type) >= 0 ? `${type}` : '';
        },
        cancelLoading() {
            this.$emit('canceled', this.file);
        },
    },
};
</script>
